import React from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import Home from './Home.js';
import Scrap from './Scrap.js';
import TodoAppPrivacyPolicy from './TodoAppPrivacyPolicy.js';

function App() {
  return (
    <>
      <HashRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/scrap" element={<Scrap />} />
          <Route
            path="/privacy_policy/todoapp"
            element={<TodoAppPrivacyPolicy />}
          />
        </Routes>
      </HashRouter>
    </>
  );
}

export default App;
